import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { apiurl } from "../../varconfig";
import { useQuery, gql } from "@apollo/client";
import { ImgHTMLAttributes, ReactNode, isValidElement, useState } from "react";
import { formatDate } from "../utils/format-date";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ReactMarkdown from "react-markdown";
import React from "react";

interface AppProps {
  url_slug: string;
  category: string
}

export default function Newspagecomp(props: AppProps) {
  const [isLoadState, setIsLoadState] = useState(true);
  const [apiData, setapiData] = useState({
    data: [
      {
        id: 0,
        title: "Loading...",
        date: "loading...",
        url: "Loading..",
        description: "<p>Loading... Please wait...</p>",
        attachment: "Loading..",
      },
    ],
    lastPage: true,
    currentPage: 1,
  });

  const matches = useMediaQuery("(min-width:840px)");
  const matches1 = useMediaQuery("(max-width:380px)");

  const GET_PAGE = gql`
  query {
    ${props.url_slug}(
      pagination: { page: ${apiData.currentPage}, pageSize: 4 }
      sort: ["date:desc"]
    ) {
      meta {
        pagination {
          pageCount
        }
      }
      data {
        id
        attributes {
          title
          date
          url
          description
          attachment {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
  `;
  const { loading, error, data, refetch } = useQuery(GET_PAGE, {
    onCompleted(data) {
      let data_array: any = [];

      data[props.url_slug]?.data.forEach((each: any) => {
        let fDate = formatDate(each?.attributes.date);
        data_array.push({
          id: each?.id,
          title: each?.attributes.title,
          description: each?.attributes.description.replaceAll(
            'src="/uploads',
            `src=\"${apiurl}/uploads`
          ),
          date: `${fDate.day} ${fDate.monthShort}, ${fDate.year}`,
          url: each?.attributes.url,
          attachment: each?.attributes.attachment.data ? each?.attributes.attachment.data?.attributes.url : "NA",
        });
      });
      setapiData({
        data: data_array,
        lastPage:
          data.news?.meta?.pagination.pageCount === apiData.currentPage
            ? true
            : false,
        currentPage: apiData.currentPage,
      });
      setIsLoadState(false);
    },
  });
  function circloader() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          width: "100vw",
        }}
      >
        <CircularProgress />
        <h4>Loading...</h4>
      </div>
    );
  }
  function leftClick() {
    setapiData({
      data: apiData.data,
      lastPage: apiData.lastPage,
      currentPage: apiData.currentPage - 1 < 1 ? 1 : apiData.currentPage - 1,
    });
    refetch();
  }
  function rightClick() {
    setapiData({
      data: apiData.data,
      lastPage: apiData.lastPage,
      currentPage: apiData.currentPage + 1,
    });
    refetch();
  }
  function navButtons() {
    let lbs = true;
    apiData.currentPage === 1 ? (lbs = true) : (lbs = false);

    return (
      <div
        style={{
          justifyContent: "center",
          paddingTop: "20px",
          paddingBottom: "20px",
          display: "flex",
        }}
      >
        <div>
          {apiData.currentPage !== 1 ? (
            <>
              <Button
                variant="contained"
                color="primary"
                // disabled={lbs}
                style={{ marginRight: "10px" }}
                startIcon={<NavigateBeforeIcon />}
                onClick={leftClick}
              >
                Prev
              </Button>
            </>
          ) : (
            <></>
          )}
          {!apiData.lastPage ? (
            <>
              <Button
                variant="contained"
                color="primary"
                // disabled={apiData.lastPage}
                style={{ marginLeft: "10px" }}
                endIcon={<NavigateNextIcon />}
                onClick={rightClick}
              >
                Next
              </Button>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }

  // 1. Image Props & Component
  interface CustomImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    node?: any;
  }

  // 2. Paragraph Props
  interface ParagraphProps {
    children?: ReactNode;
    node?: any;
  }

  const CustomImage = ({ node, ...props }: CustomImageProps) => (
    <img
      {...props}
      style={{
        width: "auto",
        maxWidth: "100%",
        aspectRatio: "4 / 3", // Ensures 3:4 ratio
        display: "block",
        margin: "20px auto", // Centers the image
        borderRadius: "3px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        objectFit: "cover" // Ensures the image fills the box nicely without distortion
      }}
      
      alt={props.alt || "image"}
    />
  );
  

  
  const ImageGridParagraph = ({ children }: ParagraphProps) => {
    const childrenArray = React.Children.toArray(children);
  
    // Grouping Logic (Same as before)
    const parts: { type: 'text' | 'image-grid'; items: ReactNode[] }[] = [];
    let currentImages: ReactNode[] = [];
    let currentText: ReactNode[] = [];
  
    const flushImages = () => {
      if (currentImages.length > 0) {
        parts.push({ type: 'image-grid', items: currentImages });
        currentImages = [];
      }
    };
  
    const flushText = () => {
      if (currentText.length > 0) {
        parts.push({ type: 'text', items: currentText });
        currentText = [];
      }
    };
  
    childrenArray.forEach((child) => {
      const isImage = isValidElement(child) && child.type === CustomImage;
      const isWhitespace = typeof child === 'string' && child.trim() === '';
  
      if (isImage) {
        flushText();
        currentImages.push(child);
      } else if (isWhitespace && currentImages.length > 0) {
        // Ignore whitespace between images
      } else {
        flushImages();
        currentText.push(child);
      }
    });
  
    flushText();
    flushImages();
  
    return (
      <div style={{ marginBottom: '1rem' }}>
        {parts.map((part, index) => {
          // 1. Render Text
          if (part.type === 'text') {
            return (
              <p key={index} style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
                {part.items}
              </p>
            );
          }
  
          // 2. Render Images
          if (part.type === 'image-grid') {
              const imageCount = part.items.length;
  
              // --- CASE A: SINGLE IMAGE (Flex Center) ---
              if (imageCount === 1) {
                return (
                  <div 
                    key={index} 
                    style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      margin: '20px 0' 
                    }}
                  >
                    {part.items}
                  </div>
                );
              }
  
              // --- CASE B: MULTIPLE IMAGES (Grid) ---
              const gridChildren = React.Children.map(part.items, child => {
                  if (isValidElement(child) && child.type === CustomImage) {
                       return React.cloneElement(child as React.ReactElement<any>, {
                           style: { 
                             ...(child.props.style || {}), 
                             width: '100%',      
                             height: '200px',    
                             margin: 0,          
                             objectFit: 'cover' 
                           }
                       });
                  }
                  return child;
              });
  
              return (
                <div
                  key={index}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', 
                    gap: '15px',
                    marginTop: '15px',
                    marginBottom: '15px',
                    justifyContent: 'center'
                  }}
                >
                  {gridChildren}
                </div>
              );
          }
          return null;
        })}
      </div>
    );
  };



  function newsbody() {
    return (
      <>
        {apiData.data.length !== 0 ? (
          <Container
            style={{
              width: matches ? "80%" : "100%",
              // marginLeft: "40px",
              // marginRight: "40px",
              marginBottom: "40px",
              minHeight: "30vh",
            }}
          >
            {apiData.data?.map(function (obj, index) {
              console.log(obj.description);
              return (
                <div style={{ paddingTop: "40px" }} key={obj.id}>
                  <Card className="pdbga">
                    <CardContent>
                      <Container
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {matches ? (
                          <>
                            <h2 style={{ fontSize: "1.6rem", maxWidth: "70%" }}>
                              {obj.title}
                            </h2>
                            <p style={{ fontSize: "0.9rem" }}>
                              Published on: &nbsp;
                              {obj.date}
                            </p>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <h2 style={{ fontSize: "1.4rem" }}>{obj.title}</h2>
                            <p style={{ fontSize: "0.8rem" }}>
                              Published on: &nbsp;
                              {obj.date}
                            </p>
                          </div>
                        )}
                      </Container>

                      <div
                        style={{
                          textAlign: "justify",
                          textJustify: "inter-word",
                        }}
                        className={"ql-editor"}
                      >
                        <ReactMarkdown
                          components={{
                            // Tell ReactMarkdown to use our custom components
                            img: CustomImage,
                            p: ImageGridParagraph
                          }}
                        >
                          {obj.description}
                        </ReactMarkdown>
                      </div>
                      <div style={{ marginTop: "50px" }}>
                        {obj.url !== "NA" && obj.url !== null ? (
                          <a href={obj.url}>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{
                                marginRight: "10px",
                                marginBottom: matches1 ? "20px" : "0px",
                                fontSize: !matches ? "0.8rem" : "0.9rem",
                              }}
                            >
                              Learn More
                            </Button>
                          </a>
                        ) : (
                          <></>
                        )}
                        {obj.attachment !== "NA" && obj.attachment !== null ? (
                          <a href={apiurl + obj.attachment} download>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{
                                fontSize: !matches ? "0.7rem" : "0.9rem",
                              }}
                            >
                              Download Attachment
                            </Button>
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              );
            })}
            {navButtons()}
          </Container>
        ) : (
          <Container
            style={{
              marginBottom: "40px",
              minHeight: "43vh",
            }}
          >
            <p
              style={{
                marginTop: "40px",
                marginLeft: "40px",
              }}
            >
              No Data Available ....
            </p>
          </Container>
        )}
      </>
    );
  }

  return (
    <>
      <div>
        <h1
          style={{
            fontSize: "2.5rem",
            paddingLeft: !matches ? "30px" : "80px",
            paddingTop: "40px",
            marginBottom: "30px",
            color: "#03205c",
          }}
        >
          {props.category}
        </h1>
        {!isLoadState ? newsbody() : circloader()}
      </div>
    </>
  );
}
